<template>
<!-- 文章审核发布 -->
<section class="viewContainer">
  <div v-show="isOrder" @listenEdit="showOrder">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :model="filters" class="findform">
          <el-form-item label="文章标题：" style="display:flex;width:25%">
            <el-input v-model="filters.EnterpriseName" placeholder="请输入内容" maxlength="10" style="width:90%"/>
          </el-form-item>
          <el-form-item label="文章分类：" style="display:flex;width:25%;">
            <el-select v-model="filters.MediaType" filterable placeholder="请选择" style="width:90%">
              <el-option v-for="(item,index) in MediaTypeArr" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="文章状态：" style="display:flex;width:25%;">
            <el-select v-model="filters.articleState" filterable placeholder="请选择" style="width:90%">
              <el-option v-for="(item,index) in articleStateArr" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">文章审核发布</p>
        <div style="float: right;margin-right: 10px;">
          <el-button type="danger" @click="endDeletegood()">批量删除</el-button>
          <el-button type="danger" @click="showAdd()">新 增</el-button>
        </div>
      </section>
      <div class="table_container">
        <el-table :data="articleDataList" class="invoice_tab" stripe border @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center"/>
          <el-table-column label="序号" align="center" width="60px">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="文章标题" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.title">{{scope.row.title}}</span>
            </template>
          </el-table-column>
          <el-table-column label="文章分类" align="center">
            <template scope="scope">{{scope.row.mediaTypeName}}</template>
          </el-table-column>
          <el-table-column label="发布时间" align="center" width="160">
            <template scope="scope">{{scope.row.publishTime}}</template>
          </el-table-column>
          <el-table-column label="阅读量" align="center">
            <template scope="scope">{{scope.row.browse | playvolume}}</template>
          </el-table-column>
          <el-table-column label="收藏" align="center">
            <template scope="scope">{{scope.row.collection | playvolume}}</template>
          </el-table-column>
          "转发" align="center">
            <template scope="scope">{{scope.row.forward | playvolume}}</template>
          </el-table-column>
          <el-table-column label="评论" align="center">
            <template scope="scope">{{scope.row.comment | playvolume}}</template>
          </el-table-column>
          <el-table-column label="点赞" align="center">
            <template scope="scope">{{scope.row.fabulous | playvolume}}</template>
          </el-table-column>
          <el-table-column label="最后操作人" align="center" width="100">
            <template scope="scope">{{scope.row.lastEditUserName}}</template>
          </el-table-column>
          <el-table-column label="最后操作时间" align="center" width="160">
            <template scope="scope">{{scope.row.lastEditTime}}</template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">{{scope.row.stateName}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="235">
            <template scope="scope">
              <span class="ashSpan" v-if="scope.row.state == 3"> 审核 </span>
              <span class="handle" @click="endArticleReview(scope.row)" v-if="scope.row.state == 1">审核</span>
              <span class="handle" @click="articleUnsealed(scope.row)" v-if="scope.row.state == 2">解封</span>
              <span class="handle" @click="articlesBanned(scope.row)" v-if="scope.row.state == 4">封禁</span>
              <span class="handle" @click="cliSeePartner(scope.row)"> <i class="el-icon-view"/> 查看 </span>
              <span class="handle" @click="editArticle(scope.row)"> <i class="el-icon-edit-outline"/> 编辑 </span>
              <span class="handle" @click="deleteData(scope.row)"> <i class="el-icon-delete"/> 删除 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
      </div>
    </div>
  </div>

  <!-- 新建文章详情页 -->
  <div class="main_container" v-if="isSeePartnerPopup">
    <section class="model_section">
      <p class="model_top_title">新建文章</p>
      <el-button type="danger" @click="showOrder()" style="float: right;margin: 6px 10px 0 0;">返回</el-button>
    </section>
    <!-- 基本信息 -->
    <div class="watch_msg">
      <b class="typeface">基本信息</b>
      <el-form style="margin: 10px 0 30px 0;">
        <el-form class="formItem">
          <el-form-item label="文章名称 :" style="width:42%;" label-width="88px">
            <el-input v-model="articleTitle" placeholder="请输入文章名称 (30字以内)" maxlength="30" :disabled="disabledArticle"/>
          </el-form-item>
          <el-form-item label="文章分类 :" style="width:42%;" label-width="88px">
            <el-select v-model="articleClassification" filterable placeholder="请选择"
              style="background:#fff;width:100%" :disabled="disabledArticle">
              <el-option v-for="(item,index) in articleClassificationArr" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form-item label="封面图片 :" style="width:86%;" label-width="88px" v-show="articleClassification != 0">
          <div class="coverPhoto" style="display:inline-block">
            <template v-if="articleClassification == 0 || articleClassification == 2 && videoSrc == ''">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </template>
            <el-upload class="avatar-uploader" style action :auto-upload="false" :show-file-list="false"
              v-if="articleClassification == 1 || articleClassification == 2 && videoSrc"
              :before-upload="beforeUploadCover" :on-change='changeUpload' :disabled="disabledArticle">
              <img id="canvas" style="width:80px;height:80px" v-if="imageUrl" :src="imageUrl"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="color:#888;">建议尺寸：宽度应为1080px, 高度不小于607px，支持的图片格式：jpg、png !</div>
        </el-form-item>
        <canvas id="canvasa" hidden width=1080 height=607></canvas>
        <el-form-item label="图片 :" style="width:86%;" label-width="88px" v-if="articleClassification == 1">
          <div style="width: 100vh;display: flex;flex-wrap: wrap;">
            <div v-for="(item,index) in imgarrData" :key="index" style="display:inline-block; position: relative;">
              <img @click="deleteimg(index,item)" src="../../assets/img/aicon36.png" class="deletePicture" v-if="seeArticle"/>
              <el-image :src="item" class="imgPicture" @click="handleClickItem" :preview-src-list="imgarrData"/>
            </div>
            <el-upload class="upload avatar-uploader" v-show="isdisabled" action v-if="seeArticle"
              :show-file-list="false" :before-upload="beforeAvatarUpload" style="display:inline-block;">
              <img style="width:80px;height:80px;" v-if="CoverImg" :src="CoverImg" class="avatar"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="color:#888;"> 建议尺寸：宽度应为1080px, 高度不小于607px，支持的图片格式：jpg、png。</div>
        </el-form-item>
        <el-form-item label="视频 :" style="width:86%;" label-width="88px" v-if="articleClassification == 2">
          <div v-if="videoSrc" class="videoClass">
            <span @click="newSeevideo(videoSrc)" class="previewingVideo">
              <img :src="videoImg" v-if="videoImg">
              <img src="../../assets/img/spfm.png" v-else>
              <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
            </span>
            <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
          </div>
          <el-upload v-else class="avatar-uploader activeUploadImg" action="" accept="video/*" :before-upload="handleFile">
            <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
        </el-form-item>
        <el-form-item label="关联品牌商品：" style="width:88%;" label-width="100px">
          <i @click="addSpecialOffer" class="el-icon-plus avatarUploaderIcon" v-if="seeArticle" v-show="brandArr.length < 5"></i>
          <template v-if="isshowbrand">
            <div v-for="(item,index) in brandArr" :key="index" style="display:inline-block; position: relative;">
              <img @click="deleteBrand(index)" src="../../assets/img/aicon36.png" class="deletePP" v-if="seeArticle"/>
              <img class="brandImg" v-if="item.logoUrl" :src="item.logoUrl"/>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="添加标签：" style="width:88%;" label-width="88px">
          <span @click="choosekong" class="choice" v-if="seeLabel">添加标签 >></span>
          <span v-show="item.name" class="labelSpan" v-for="(item,index) in homenamearr" :key="index">
            {{item.name}} <i @click="deleteLabel(item.id)" class="el-icon-close" v-if="seeLabel"></i>
          </span>
        </el-form-item>
        <el-form-item label="内容 :" style="width:88%;" label-width="88px">
          <wjEditor :desc="ueditorValue" @change="contentChangeOne"/>
        </el-form-item>
        <el-form class="formItem">
          <el-form-item label="发布人 :" style="width:30%;" label-width="88px">
            <span class="publisherBtn" @click="handleAddPublisher" v-if="seeArticle"> 添加发布人 </span>
          </el-form-item>
          <el-form-item style="width:55%;" label-width="88px">
            <div style="width: 50%; text-align: center;">
              <img v-if="LogoUrl" :src="LogoUrl" style="width: 80px;height: 80px;border-radius: 50%;"/>
              <br> <b style="color: #888;">{{publisherTitle}}</b>
            </div>
          </el-form-item>
        </el-form>
      </el-form>
      <div class="gudingdibu" v-if="seeArticle">
        <el-button @click="showOrder()">取消</el-button>
        <el-button type="danger" @click="btnSubmit()">提交</el-button>
      </div>
      <div class="gudingdibu" v-if="seeAuditButton">
        <el-button type="danger" @click="adoptToExamine(1)">审核通过</el-button>
        <el-button @click="adoptToExamine(2)">拒绝通过</el-button>
      </div>
    </div>
  </div>

  <!-- 品牌店/特价商品-弹框 -->
  <el-dialog title="品牌店/特价商品" :visible.sync="brandStorePopup" :center="true" width="40%">
    <el-form style="display:flex">
      <el-form-item style="display:flex;width:50%;margin-right:10px">
        <el-input v-model="KeywordName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="handleSearch()">搜 索</el-button>
      </el-form-item>
    </el-form>
    <div class="brandDiv">
      <div class="brandStoreClass" v-for="(item,index) in brandStoreList" :key="index">
        <div class="dlStyle">
          <div class="dtDiv"><img class="dtImage" :src="item.logoUrl"/></div>
          <div class="ddDiv">
            <b>{{item.name}}</b>
            <p>{{item.address}}</p>
          </div>
        </div>
        <div class="confirmBtn" :class="{noPrice: item.type != 2}">
          <p v-if="item.type == 2">类别: <strong>{{item.goodsBrandType}}</strong></p>
          <el-button type="danger" @click="addBrandStore(item)">添 加</el-button>
        </div>
      </div>
      <p style="text-align:center" v-show="showThereIsNoResult">查无结果</p>
    </div>
  </el-dialog>

  <!-- 标签弹框 -->
  <el-dialog title="标签" :visible.sync="labelPopup" width="800px" :before-close="handleClose2">
    <div class="chooseDia">
      <div v-for="(item,index) in homearr" :key="index">
        <div class="searchTop"><span>{{item.name}}</span></div>
        <div class="searchBot">
          <p :class="{activeP: isSelect(item.id)}" v-for="(item,index) in item.tag" :key="index" @click="endSelectLabel(item)">{{item.name}}</p>
        </div>
      </div>
      <!-- <span class="searchTop">户型</span>
      <div class="searchBot">
        <p :class="{activeP: isSelect(item)}" v-for="(item,index) in homearr.houseType" :key="index" @click="endSelectLabel(item, index, 'houseType')">{{item}}</p>
      </div>

      <span class="searchTop">风格</span>
      <div class="searchBot">
        <p :class="{activeP: isSelect(item)}" v-for="(item,index) in homearr.style" :key="index" @click="endSelectLabel(item, index, 'style')">{{item}}</p>
      </div>

      <span class="searchTop">空间</span>
      <div class="searchBot">
        <p :class="{activeP: isSelect(item)}" v-for="(item,index) in homearr.space" :key="index" @click="endSelectLabel(item, index, 'space')">{{item}}</p>
      </div>

      <span class="searchTop">施工阶段</span>
      <div class="searchBot">
        <p :class="{activeP: isSelect(item)}" v-for="(item,index) in homearr.constructionStage" :key="index" @click="endSelectLabel(item, index, 'constructionStage')">{{item}}</p>
      </div>

      <span class="searchTop">主材分类</span>
      <div class="searchBot">
        <p :class="{activeP: isSelect(item)}" v-for="(item,index) in homearr.mainMaterialType" :key="index" @click="endSelectLabel(item, index, 'mainMaterialType')">{{item}}</p>
      </div> -->

    </div>
    <div class="chooseBtn">
      <el-button type="danger" @click="preservationLabel">保 存</el-button>
    </div>
  </el-dialog>

  <!-- 审核二次确认弹框 -->
  <el-dialog title="审核" :center="true" class="add_order_cancle" width="30%" :visible.sync="isToExamine">
    <el-form>
      <el-form-item>
        <el-input type="textarea" placeholder="请输入审核备注" maxlength="200" v-model="shenmark" :rows="3"/>
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button type="danger" v-show="seeAdopt" @click="endToExamine(true)">确认审核</el-button>
      <el-button type="danger" v-show="seeRefuse" @click="endToExamine(false)">拒绝</el-button>
      <el-button @click="isToExamine = false">取 消</el-button>
    </div>
  </el-dialog>

  <!-- 选择发布人 -->
  <el-dialog title="选择发布人" :visible.sync="xzfbr" width="35%" center>
    <el-form label-width="100px" style="display:flex">
      <el-form-item label="发布人手机号：" style="width:60%;margin-right:10px">
        <el-input v-model="publisherPhone" placeholder="请输入发布人手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="finddes()">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="disoutline">
      <p @click="handleGetdesId(item)" v-for="(item,index) in desarr" :key="index" class="disinline">
        <img :src="item.faceUrl"/>
        <span>{{item.nickName}}</span>
        <el-radio v-model="choiceRadioId" :label="item.id" class="elRadio">选择</el-radio>
      </p>
      <p style="text-align:center" v-show="nofind">查无结果</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="makedes()">确 定</el-button>
      <el-button @click="xzfbr = false">取 消</el-button>
    </div>
  </el-dialog>

  <!-- vueCropper 剪裁图片实现-->
  <el-dialog title="图片剪裁" :visible.sync="cropping" append-to-body center>
    <div class="cropper-content">
      <div class="cropper">
        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :fixedBox="option.fixedBox"
        :outputType="option.outputType" :full="option.full" :canMove="option.canMove" :infoTrue="option.infoTrue"
        :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :info="true"
        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
        :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"/>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cropping = false">取 消</el-button>
      <el-button type="primary" @click="finish">确认</el-button>
    </div>
  </el-dialog>

  <!-- 播放视频 -->
  <el-dialog title="视频播放" :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, UploadImgForServer, uploadVedio } from '../../api/newOss';
import wjEditor from '../../components/MyWangEditor';
import { getArticleVideoList, postAddArticleVideo, putUpdateArticleVideo,
 getArticleVideoUpdateDetails, getArticleVideoSeeDetails, deleteArticleVideo, getArticleVideoJzUser, postBan,
 getBrandBusinessAndGoods, getLabel, postApproval } from "../../api/decoration";
export default {
  name: 'articleReviewAndRelease',
  mixins: [alertTrends],
  data() {
    return {
      show3: true, // 查询区域默认展开
      peopleId: "", // id
      isOrder: true, // 列表页
      isSeePartnerPopup: false, // 详情页
      articleDataList: [], // 查询列表
      goodIdarr:[], // 复选框选中项
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      filters: {
        EnterpriseName: "", // 文章标题
        MediaType: 0, // 文章分类
        articleState: 0, // 文章状态
      },
      MediaTypeArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "文章"
        },
        {
          Id: 2,
          Name: "视频"
        }
      ],
      articleStateArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "审核中"
        },
        {
          Id: 2,
          Name: "封禁"
        },
        {
          Id: 3,
          Name: "未通过"
        },
        {
          Id: 4,
          Name: "已通过"
        }
      ],
      disabledArticle: false, // 默认不禁用
      seeArticle: true, // 显隐
      articleTitle: "", // 文章名称
      articleClassification: 0, // 文章分类
      articleClassificationArr: [
        {
          Id: 1,
          Name: "文章"
        },
        {
          Id: 2,
          Name: "视频"
        }
      ],
      
      imgarrData: [], // 全连接
      FileID: [], // 切割之后的
      isdisabled: true,
      
      brandStorePopup: false, // 品牌店/特价商品
      KeywordName: "", // 搜索内容
      brandStoreList: [], // 关联品牌店/特价商品列表
      showThereIsNoResult: false, // 查无结果
      brandArr: [], // 品牌店回显
      isshowbrand: false,
      
      labelPopup: false, // 标签弹框
      homearr: [], // 标签列表
      tempTag: [], // 标签-临时选中项
      homenamearr: [], // 标签回显
            
      isToExamine: false, // 审核弹框
      shenmark: "", // 审核意见
      seeAdopt: false, // 通过按钮
      seeRefuse: false, // 拒绝按钮

      // 内容
      ueditorValue: '',
      publisherTitle: "", // 发布人名称回显
      LogoUrl: "", // 头像 - 全链接回显
      
      xzfbr: false, // 选择发布人弹框
      publisherPhone: "", // 发布人手机号
      desarr: [], // 发布人列表
      choiceRadioId: "", // 发布人id
      choiceRadioName: "", // 发布人姓名
      choiceRadioHeadPortrait: "", // 发布人头像
      nofind:false, // 查无结果
      seeAuditButton: false, // 审核按钮

      seeLabel: true, // 添加标签及删除标签显隐

      cropping: false, // 图片裁剪弹框
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1080, // 默认生成截图框宽度
        autoCropHeight: 607, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1080, 607], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        
      },
      picsList: [],  //页面显示的数组
      
      imageUrl: "", // 封面图 全链接
      imageUrlQiege: "", // 封面图 切割路径
      imgsrc: "",
      CoverImg:"",
      videoImg: '', // 视频封面图
      videoSrc: "", // 视频全连接
      videoShortSrc: "", // 短
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频播放
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
    }
  },
  components: { wjEditor },
  methods: {
    // 查询列表
    getInit() {
      let addParams = {
        Title: this.filters.EnterpriseName, // 标题
        MediaType: this.filters.MediaType, // 类型  0=全部、1=文章、2=类型
        State: this.filters.articleState, // 状态  0=全部；1=审核中；2=封禁；3=未通过；4=已通过
        pageIndex: this.pageIndex,// 页码
        pageSize: this.pageSize // 每页行数
      };
      getArticleVideoList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.articleDataList = data.resultObj.resultObj;
            this.totalRowsCount = data.resultObj.rowsCount;
          } else {
            this.articleDataList = [];
            this.totalRowsCount = 0;
          }
        } else {
          this.articleDataList = [];
          this.totalRowsCount = 0;
        }
      })
    },
    // 返回 显示主页
    showOrder() {
      this.isOrder = true; // 主页
      this.isSeePartnerPopup = false; // 详情页
    },
    // 新增
    showAdd() {
      this.isOrder = false; // 主页
      this.isSeePartnerPopup = true; // 详情页
      
      this.seeAuditButton = false; // 审核按钮
      this.disabledArticle = false;
      this.seeArticle = true;
      this.seeLabel = true;
      
      this.peopleId = "", // 置空id
      this.articleTitle = "", // 文章名称
      this.articleClassification = "", // 文章分类
      this.imageUrl = ""; //  清空封面图片
      this.imageUrlQiege='';
      this.imgarrData = []; // 清空多图
      this.FileID = [];
      this.isdisabled = true;
      this.CoverImg = ""
      this.videoSrc = ""; // 清空店铺视频
      this.brandArr = [];
      this.homenamearr = [];
      this.ueditorValue = ""; // 清空内容
      this.publisherTitle = ""; // 清空发布人名称
      this.LogoUrl = ""; // 清空头像
    },
    // 查看 回显数据
    cliSeePartner(row) {
      this.peopleId = row.id; // id
      this.isOrder = false; // 主页
      this.isSeePartnerPopup = true; // 详情页查看
      
      this.seeAuditButton = false; // 审核按钮
      this.disabledArticle = true;
      this.seeArticle = false;
      this.seeLabel = false;

      var addParams = {
        id: this.peopleId // id
      };
      getArticleVideoSeeDetails(addParams).then(data => {
        let newResultObj = data.resultObj;
        this.articleTitle = newResultObj.title; // 标题
        this.articleClassification = newResultObj.mediaType; // 类型；1=文章、2=视频

        this.imageUrl = localStorage.BaseOssUrl + newResultObj.coverImg; // 封面图 - 全链接
        this.imageUrlQiege = newResultObj.coverImg; // 封面图 - 短连接

        // 关联品牌店或商品集合
        let neDataArr = JSON.parse(JSON.stringify(newResultObj.relatedGoodsAndStores));
        for(var i = 0; i < neDataArr.length; i++) {
          neDataArr[i].logoUrl = neDataArr[i].logoUrl.replace('', localStorage.BaseOssUrl)
        }
        this.brandArr = neDataArr; // 连接集合
        
        // 标签回显
        this.homenamearr = newResultObj.tag;
        // this.homenamearr = [
        //   {value: newResultObj.houseTypeName, index: newResultObj.houseType, tagType: "houseType"},
        //   {value: newResultObj.styleName, index: newResultObj.style, tagType: "style"},
        //   {value: newResultObj.spaceName, index: newResultObj.space, tagType: "space"},
        //   {value: newResultObj.constructionStageName, index: newResultObj.constructionStage, tagType: "constructionStage"},
        //   {value: newResultObj.goodsTypeName, index: newResultObj.goodsType, tagType: "mainMaterialType"},
        // ];
        
        this.ueditorValue = newResultObj.content; // 内容

        this.choiceRadioId = newResultObj.publisherId; // 发布人id
        this.publisherTitle = newResultObj.publisherName; // 回显发布人名称
        this.LogoUrl = newResultObj.faceUrl; // 头像 - 全链接回显

        if(this.articleClassification == 1) {
          // if (newResultObj.links.length >= 13) {
          //   this.isdisabled = false;
          // } else {
          //   this.isdisabled = true;
          // }
          
          // 回显多图
          let linksImgData = JSON.parse(JSON.stringify(newResultObj.links));
          for(var i = 0; i < linksImgData.length; i++) {
            linksImgData[i] = linksImgData[i].replace('', localStorage.BaseOssUrl)
          }
          this.imgarrData = linksImgData; // 多图 连接集合
          this.FileID = newResultObj.links; // 多图 连接集合 - 短连接
        } else {
          this.videoSrc = localStorage.BaseOssUrl + newResultObj.links[0]; // 视频 连接集合
          this.videoShortSrc = newResultObj.links[0]; // 视频 连接集合 - 短连接
        }
      })
    },
    // 编辑
    editArticle(row) {
      this.peopleId = row.id; // id
      this.isOrder = false; // 主页
      this.isSeePartnerPopup = true; // 详情页查看
      
      this.seeAuditButton = false; // 审核按钮
      this.disabledArticle = false;
      this.seeArticle = true;
      this.seeLabel = true;
      
      var addParams = {
        id: this.peopleId // id
      };
      getArticleVideoUpdateDetails(addParams).then(data => {
        let newResultObj = data.resultObj;
        this.articleTitle = newResultObj.title; // 标题
        this.articleClassification = newResultObj.mediaType; // 类型；1=文章、2=视频
        
        this.imageUrl = localStorage.BaseOssUrl + newResultObj.coverImg; // 封面图 - 全链接
        this.imageUrlQiege = newResultObj.coverImg; // 封面图 - 短连接

        // 关联品牌店或商品集合
        let neDataArr = JSON.parse(JSON.stringify(newResultObj.relatedGoodsAndStores));
        for(var i = 0; i < neDataArr.length; i++) {
          neDataArr[i].logoUrl = neDataArr[i].logoUrl.replace('', localStorage.BaseOssUrl)
        }
        this.brandArr = neDataArr; // 连接集合
        
        // 标签回显
        this.homenamearr = newResultObj.tag;
        // this.homenamearr = [
        //   {value: newResultObj.houseTypeName, index: newResultObj.houseType, tagType: "houseType"},
        //   {value: newResultObj.styleName, index: newResultObj.style, tagType: "style"},
        //   {value: newResultObj.spaceName, index: newResultObj.space, tagType: "space"},
        //   {value: newResultObj.constructionStageName, index: newResultObj.constructionStage, tagType: "constructionStage"},
        //   {value: newResultObj.goodsTypeName, index: newResultObj.goodsType, tagType: "mainMaterialType"},
        // ];
        
        this.ueditorValue = newResultObj.content; // 内容

        this.choiceRadioId = newResultObj.publisherId; // 发布人id
        this.publisherTitle = newResultObj.publisherName; // 回显发布人名称
        this.LogoUrl = newResultObj.faceUrl; // 头像 - 全链接回显
        
        if(this.articleClassification == 1) {
          if (newResultObj.links.length >= 15) {
            this.isdisabled = false;
          } else {
            this.isdisabled = true;
          }
          
          // 回显多图
          let linksImgData = JSON.parse(JSON.stringify(newResultObj.links));
          for(var i = 0; i < linksImgData.length; i++) {
            linksImgData[i] = linksImgData[i].replace('', localStorage.BaseOssUrl)
          }
          this.imgarrData = linksImgData; // 多图 连接集合
          this.FileID = newResultObj.links; // 多图 连接集合 - 短连接
        } else {
          this.videoSrc = localStorage.BaseOssUrl + newResultObj.links[0]; // 视频 连接集合
          this.videoShortSrc = newResultObj.links[0]; // 视频 连接集合 - 短连接
        }
      })
    },
    // 提交
    btnSubmit() {
      setTimeout(()=>{
      if(this.articleTitle == ""){
        this.showAlert('请输入文章名称');
        return false;
      }
      if(this.articleClassification == 0){
        this.showAlert('请选择文章分类');
        return false;
      }
      if(this.articleClassification == 1 && this.imageUrl == ""){
        this.showAlert('请上传封面图片');
        return false;
      }
      if(this.articleClassification == 1 && this.imgarrData.length == 0){
        this.showAlert('请上传文章图片');
        return false;
      }
      if(this.articleClassification == 2 && this.videoSrc == ""){
        this.showAlert('请上传文章视频');
        return false;
      }
      // if(this.brandArr.length == 0){
      //   this.showAlert('请上传关联品牌商品');
      //   return false;
      // }
      // if(this.homenamearr.length == 0){
      //   this.showAlert('请添加标签');
      //   return false;
      // }
      if(this.ueditorValue == ""){
        this.showAlert('请编写内容');
        return false;
      }
      if(this.LogoUrl == ""){
        this.showAlert('请添加发布人');
        return false;
      }
      
      // 构造标签列表
      // var aaa = this.tempTag.map(item=>item.tagType == 'houseType' ? item.id : 0);

      // var bbb = this.tempTag.map(item => {
      //   return {[item.tagType]:item.id}
      // })
      // var data = {}
      // bbb.map(item=>Object.assign(data,item))

      var vvv = this.homenamearr.map(item => {
        if(item.id) {
          return item.id
        }
      })

      if(this.peopleId) {
        var addParams = {
          userId: localStorage.Id, // 操作人id
          id: this.peopleId, // id
          title: this.articleTitle, // 标题
          mediaType: this.articleClassification, // 类型 1=文章、2=视频
          coverImg: this.imageUrlQiege, // 封面图
          content: this.ueditorValue, // 内容
          publisherId: this.choiceRadioId, // 发布人id
          links: this.articleClassification == 1 ? this.FileID : [this.videoShortSrc], // 多图入参 & 视频
          goodsAndStores: this.brandArr, // 关联品牌商或商品集合
          tag: vvv // 标签集合  int类型数组
        };
        // Object.assign(addParams, data)
        putUpdateArticleVideo(addParams).then(data => {
          if(data.resultCode == 1) {
            this.showAlert(data.resultMsg, 'success');
            this.isOrder = true; // 主页
            this.isSeePartnerPopup = false; // 详情页
            this.getInit();
          } else {
            this.showAlert(data.resultMsg);
          }
        })
      } else {
        var addParams = {
          userId: localStorage.Id, // 操作人id
          title: this.articleTitle, // 标题
          mediaType: this.articleClassification, // 类型 1=文章、2=视频
          coverImg: this.imageUrlQiege, // 封面图
          content: this.ueditorValue, // 内容
          publisherId: this.choiceRadioId, // 发布人id
          links: this.articleClassification == 1 ? this.FileID : [this.videoShortSrc], // 多图入参 & 视频
          goodsAndStores: this.brandArr, // 关联品牌商或商品集合
          tag: vvv // 标签集合  int类型数组
        };
        // Object.assign(addParams, data)
        postAddArticleVideo(addParams).then(data => {
          if(data.resultCode == 1) {
            this.showAlert(data.resultMsg, 'success');
            this.isOrder = true; // 主页
            this.isSeePartnerPopup = false; // 详情页
            this.getInit();
          } else {
            this.showAlert(data.resultMsg);
          }
        })
      }
      },300)
    },
    // 审核
    endArticleReview(row) {
      this.peopleId = row.id; // id
      this.isOrder = false; // 主页
      this.isSeePartnerPopup = true; // 详情页查看
      this.seeAuditButton = true; // 审核按钮
      this.disabledArticle = true;
      this.seeArticle = false;
      this.seeLabel = true;

      var addParams = {
        id: this.peopleId // id
      };
      getArticleVideoSeeDetails(addParams).then(data => {
        let newResultObj = data.resultObj;
        this.articleTitle = newResultObj.title; // 标题
        this.articleClassification = newResultObj.mediaType; // 类型；1=文章、2=视频

        this.imageUrl = localStorage.BaseOssUrl + newResultObj.coverImg; // 封面图 - 全链接
        this.imageUrlQiege = newResultObj.coverImg; // 封面图 - 短连接

        // 关联品牌店或商品集合
        let neDataArr = JSON.parse(JSON.stringify(newResultObj.relatedGoodsAndStores));
        for(var i = 0; i < neDataArr.length; i++) {
          neDataArr[i].logoUrl = neDataArr[i].logoUrl.replace('', localStorage.BaseOssUrl)
        }
        this.brandArr = neDataArr; // 连接集合
        
        // 标签回显
        this.homenamearr = newResultObj.tag;
        // this.homenamearr = [
        //   {value: newResultObj.houseTypeName, index: newResultObj.houseType, tagType: "houseType"},
        //   {value: newResultObj.styleName, index: newResultObj.style, tagType: "style"},
        //   {value: newResultObj.spaceName, index: newResultObj.space, tagType: "space"},
        //   {value: newResultObj.constructionStageName, index: newResultObj.constructionStage, tagType: "constructionStage"},
        //   {value: newResultObj.goodsTypeName, index: newResultObj.goodsType, tagType: "mainMaterialType"},
        // ];
        
        this.ueditorValue = newResultObj.content; // 内容

        this.choiceRadioId = newResultObj.publisherId; // 发布人id
        this.publisherTitle = newResultObj.publisherName; // 回显发布人名称
        this.LogoUrl = newResultObj.faceUrl; // 头像 - 全链接回显

        if(this.articleClassification == 1) {
          // if (newResultObj.links.length >= 13) {
          //   this.isdisabled = false;
          // } else {
          //   this.isdisabled = true;
          // }
          
          // 回显多图
          let linksImgData = JSON.parse(JSON.stringify(newResultObj.links));
          for(var i = 0; i < linksImgData.length; i++) {
            linksImgData[i] = linksImgData[i].replace('', localStorage.BaseOssUrl)
          }
          this.imgarrData = linksImgData; // 多图 连接集合
          this.FileID = newResultObj.links; // 多图 连接集合 - 短连接
        } else {
          this.videoSrc = localStorage.BaseOssUrl + newResultObj.links[0]; // 视频 连接集合
          this.videoShortSrc = newResultObj.links[0]; // 视频 连接集合 - 短连接
        }
      })
    },
    // 解封
    articleUnsealed(row) {
      this.$swal({
        type: "warning",
        text: "您确定解封吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = {
            userId: localStorage.Id,
            id: row.id,
            ban: false
          };
          postBan(obj).then((data) => {
            if (data.resultCode == 1) {
              this.showAlert('解封成功', 'success');
              this.getInit();
            }
          });
        }
      });
    },
    // 封禁
    articlesBanned(row) {
      this.$swal({
        type: "warning",
        text: "您确定封禁吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = {
            userId: localStorage.Id,
            id: row.id,
            ban: true
          };
          postBan(obj).then((data) => {
            if (data.resultCode == 1) {
              this.showAlert('封禁成功', 'success');
              this.getInit();
            }
          });
        }
      });
    },
    // + 添加 品牌店/特价商品
    addSpecialOffer() {
      this.brandStorePopup = true;
      this.KeywordName = ""; // 清空搜索内容
      this.brandStoreList = []; // 清空产品
      this.showThereIsNoResult = true;
    },
    // 搜 索
    handleSearch() {
      this.showThereIsNoResult = false;
      this.brandStoreList = [];
      this.handleBrand();
    },
    // 查询关联品牌店/特价商品列表
    handleBrand() {
      var obj = {
        key: this.KeywordName, // 关键字
        provinceId: 0, // 省份id   0查全部
        cityId: 0, // 城市id   0查全部
        zoneId: 0 // 区县id   0查全部
      };
      getBrandBusinessAndGoods(obj).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.brandStoreList = data.resultObj;
            this.showThereIsNoResult = false;
          } else {
            this.showThereIsNoResult = true;
          }
        } else {
          this.showThereIsNoResult = true;
        }
      });
    },
    // 添加 品牌店/特价商品
    addBrandStore(item) {
      this.brandArr.push(item);
      this.brandStorePopup = false;
    },
    // 删除品牌
    deleteBrand(index) {
      this.brandArr.splice(index, 1);
    },
    // 添加标签
    choosekong() {
      this.tempTag = this.homenamearr; // 重新构造
      this.labelPopup = true;
      this.shanchang();
    },
    // 删除标签
    deleteLabel(itemId) {
      this.homenamearr = this.homenamearr.filter(i => i.id != itemId);
    },
    handleClose2() {
      this.labelPopup = false;
    },
    //获取标签列表
    shanchang() {
      var obj = {};
      getLabel(obj).then(data => {
        if (data.resultCode == 1) {
          this.homearr = data.resultObj;
        }
      });
    },
    isSelect(newId){
      // 判断这个tag有没有被选中
      return this.tempTag.find(item=> item.id == newId)
    },
    // 选择标签
    // endSelectLabel(item, index, tagType) {
    //   if(this.tempTag.find(i=>i.value==item)){ // 取消选择
    //     var t = this.tempTag.filter((i) => i.tagType != tagType);
    //     this.tempTag = t;
    //   }else{ // 选择
    //     var t = this.tempTag.filter((i) => i.tagType != tagType);
    //     t.push({value:item, id: index, tagType});
    //     this.tempTag = t;
    //   }
    // },

    // 新版本 - 选择标签
    endSelectLabel(item) {
      if(this.tempTag.find(i => i.id == item.id)){ // 取消选择
        var t = this.tempTag.filter((i) => i.id != item.id);
        this.tempTag = t;
      }else{ // 选择
        if(this.tempTag.length == 5) {
          this.tempTag.splice(0, 1)
        }
        var t = this.tempTag.filter((i) => i.id != item.id);
        t.push(item)
        this.tempTag = t;
      }
    },

    // 保存标签
    preservationLabel() {
      this.homenamearr = this.tempTag; // 赋值回显标签
      this.labelPopup = false;
    },
    // 审核按钮
    adoptToExamine(val) {
      this.shenmark = ""; // 清空备注
      if(val == 1) {
        this.seeAdopt = true;
        this.seeRefuse = false;
      }else {
        this.seeRefuse = true;
        this.seeAdopt = false;
      }
      this.isToExamine = true; // 审核弹框展示
    },
    // 审核通过&拒绝
    endToExamine(stateVal) {
      if (this.shenmark == "") {
        this.showAlert('请输入审核备注');
        return false;
      }
      // var labelId = this.homenamearr.map(item => {
      //   return {[item.tagType]:item.index}
      // })
      // var data = {}
      // labelId.map(item=>Object.assign(data,item))

      var vvv = this.homenamearr.map(item => {
        if(item.id) {
          return item.id
        }
      })

      var addParams = {
        id: this.peopleId, // 文章视频id
        state: stateVal, // 审核状态   true=审核通过、false=审核不通过
        userId: localStorage.Id, // 操作人id
        remark: this.shenmark, // 备注
        // houseType: data.houseType, // 户型id
        // style: data.style, // 风格id
        // space: data.space, // 空间id
        // constructionStage: data.constructionStage, // 施工阶段id
        // goodsType: data.goodsType, // 主材分类id
        tag: vvv // 标签集合    int类型数组
      };
      // Object.assign(addParams, data)
      postApproval(addParams).then(data => {
        if(data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.isToExamine = false;
          this.isOrder = true; // 主页
          this.isSeePartnerPopup = false; // 详情页查看
          this.getInit();
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 批量删除
    endDeletegood(){
      if(this.goodIdarr.length == 0){
        this.showAlert('请选择需要删除的数据');
        return false;
      }
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = this.goodIdarr
          deleteArticleVideo(obj).then(data=>{
            if(data.resultCode == 1){
              this.showAlert('操作成功', 'success');
              this.getInit()
            }
          })
        }
      })
    },
    // 单条删除-列表数据
    deleteData(row){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = [row.id]
          deleteArticleVideo(obj).then(data=>{
            if(data.resultCode == 1){
              this.showAlert('操作成功', 'success');
              this.getInit();
            }
          })
        }
      })
    },
    // 点击选择发布人
    handleAddPublisher() {
      this.publisherPhone = "";
      this.choiceRadioId = "";
      this.xzfbr = true;

      var obj = {
        key: this.publisherPhone // 发布人手机号
      };
      getArticleVideoJzUser(obj).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.desarr = data.resultObj;
            this.nofind = false;
          } else {
            this.desarr = [];
            this.nofind = true;
          }
        } else {
          this.desarr = [];
          this.nofind = true;
        }
      });
    },
    // 查询发布人
    finddes() {
      var obj = {
        key: this.publisherPhone // 发布人手机号
      };
      getArticleVideoJzUser(obj).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.desarr = data.resultObj;
            this.nofind = false;
          } else {
            this.desarr = [];
            this.nofind = true;
          }
        } else {
          this.desarr = [];
          this.nofind = true;
        }
      });
    },
    // 选中发布人区域
    handleGetdesId(val) {
      this.choiceRadioId = val.id; // 获取发布人id
      this.choiceRadioName = val.nickName; // 获取发布人姓名
      this.choiceRadioHeadPortrait = val.faceUrl; // 获取发布人头像
    },
    // 确定选择发布人
    makedes() {
      if (this.choiceRadioId == "") {
        this.showAlert('请选择设计师');
        return false;
      }
      this.xzfbr = false;
      this.publisherTitle = this.choiceRadioName; // 赋值发布人名称
      this.LogoUrl = this.choiceRadioHeadPortrait; // 赋值发布人头像
    },
    // 删除图片
    deleteimg(index) {
      this.imgarrData.splice(index, 1);
      this.FileID.splice(index, 1);
      if (this.imgarrData.length >= 15) {
        this.isdisabled = false;
      }else{
        this.isdisabled = true;
      }
    },
    // 上传封面图片
    beforeUploadCover(file, val) {
      const isJPG = file.type
      if (isJPG !='image/jpeg'&&isJPG !='image/png'){
        this.showAlert('上传图片格式应为jpg/png');
        return false
      }
      const isSize = new Promise(function(resolve, reject) {
        let width = 1080;
        let height = 607;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height >= height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          var obj = {
            base64Img: e.target.result,
            uploadType: 15
          };
          UploadImgForServer(obj).then(data => {
            if (data.ResultCode == 1) {
              that.imageUrl = localStorage.BaseUrl + data.ResultObj;
              that.imageUrlQiege = data.ResultObj;
              that.cropping = false; // 图片裁剪弹框
            }
          });
        };
      },() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // 上传成功后将图片地址赋值给裁剪框显示图片
          that.$nextTick(() => {
            that.option.img = e.target.result
            that.cropping = true; // 图片裁剪弹框
            setTimeout(()=>{
              // document.querySelector('.crop-info').setHTML("1080 x 607")
              document.querySelector('.crop-info').innerHTML = '1080 x 607'
            },300)
          })
          return
        };
        // this.showAlert('上传图片宽度应为1080px, 高度不小于607px');
      });
    },
    // 上传按钮   限制图片大小
    changeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!')
        return false
      }
      this.fileinfo = file
      this.beforeUploadCover(file.raw, true)
  
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob(data => {
        var canvas=document.getElementById("canvasa");
        var ctx=canvas.getContext("2d");
        let _URL = window.URL || window.webkitURL;
        var img=new Image();
        img.onload=start;
        img.src=_URL.createObjectURL(data);
        function start(){
          canvas.width=1080;
          canvas.height=607;
          var w=img.width;
          var h=img.height;
          var sizer=Math.min((canvas.width/w),(canvas.height/h));
          ctx.drawImage(img,0,0,w,h,0,0,w*sizer,h*sizer);
          var dataURL = canvas.toDataURL('image/png');
          var getRes = dataURL;//读取的结果在result中
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
          }
          var file = dataURLtoFile(getRes)
          that.beforeUploadCover(file)
        }
      })
    },
    // 上传文章图片
    beforeAvatarUpload(file) {
      const isSize = new Promise(function(resolve, reject) {
      let width = 1080;
      let height = 607;
      let _URL = window.URL || window.webkitURL;
      let img = new Image();
      img.onload = function() {
        let valid = img.width == width && img.height >= height;
        valid ? resolve() : reject();
      };
      img.src = _URL.createObjectURL(file);
      }).then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
        that.handleOss(15); // oss 直传图片
        var newOssPic = await uploadOSS(file,0);
        that.imgarrData.push(newOssPic);
        that.FileID.push(newOssPic.replace(localStorage.BaseOssUrl,''));
      };
      if (that.imgarrData.length >= 14) {
        that.isdisabled = false;
      }
      return file;
      },() => {
        this.showAlert('上传图片宽度应为1080px, 高度不小于607px');
        return Promise.reject();
      });
      return isSize;
    },
    // 上传店铺视频
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.showAlert('请上传小于50MB的视频');
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.showAlert('请上传mp4格式的视频');
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      let obj2 = new FormData();
      obj2.append('file',file);
      //上传视频获取路径
      uploadVedio(obj2, 8).then(data=>{
        if(data.resultCode == 1){
          this.imageUrlQiege = data.resultObj.r_png;
          this.imageUrl = localStorage.BaseOssUrl + data.resultObj.r_png;
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8;
          this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl,'')
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else {
          this.showAlert(data.resultMsg, 'error');
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }
      }).catch(error => {
        this.showAlert('上传失败', 'error');
      });

    },
    // 新版本上传oss预览
    newSeevideo(){
      this.palySeevideo(this.videoSrc);
      // window.open(this.videoSrc);
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;

    },
    closeVideo() {
      // this.$refs.videoPlayer.player.play() // 播放
      // this.$refs.videoPlayer.player.pause() // 暂停
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg='';
          this.videoSrc='';
          this.videoShortSrc='';
        }
      }).catch(() => {
        return;
      });
    },
    //截取视频第一帧作为播放前默认图片
    findvideocover(url,file) {
      // const  video = document.getElementById("upvideo"); // 获取视频对象
      // 获取上传的视频的宽高
      var videoSrc = URL.createObjectURL(file);
      var videoWidthNum;
      var videoHeightNum;
      const video = document.createElement("video") // 也可以自己创建video
      video.onloadedmetadata = function (evt) {
        URL.revokeObjectURL(videoSrc);
        var videoRate=video.videoHeight/video.videoWidth
        videoWidthNum=video.videoWidth>1080?1080:video.videoWidth;
        videoHeightNum=videoWidthNum*videoRate;
        console.log(videoWidthNum,videoHeightNum);
        // 执行上传的方法，获取外网路径，上传进度等
      };
        console.log(url,"urlurlurl")
        video.src=url // url地址 url跟 视频流是一样的

      // var canvas = document.getElementById("canvas");
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      video.crossOrigin = 'anonymous' // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1 // 第一帧
      video.oncanplay = async () => {
        console.log(video,"urlurlurl")
        canvas.width = videoWidthNum; // 获取视频宽度
        canvas.height = videoHeightNum; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, videoWidthNum,videoHeightNum)
        // console.log(canvas.toDataURL("image/png"),'转换后')
        // 转换成base64形式
        this.imgsrc = canvas.toDataURL("image/png") // 截取后的视频封面
        // file.url=this.imgsrc;
        // var obj = {
        //   base64Img: this.imgsrc,
        //   uploadType: 3
        // };
        // UploadImgForServer(obj).then(data => {
        //   if (data.ResultCode == 1) {
        //     this.imageUrl = localStorage.BaseUrl + data.ResultObj;
        //     this.imageUrlQiege = data.ResultObj;
        //   }
        // });

        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
          while(n--){
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, {type:mime});
        }
        var file = dataURLtoFile(this.imgsrc)
        that.handleOss(3); // oss 直传图片
        var newOssPic = await uploadOSS(file,0);
        this.imageUrl = newOssPic;
        this.imageUrlQiege = newOssPic.replace(localStorage.BaseOssUrl,'')

      }
    },
    // 复选框
    handleSelectionChange(val) {
      this.goodIdarr = [];
      val.forEach(element => {
        this.goodIdarr.push(element.id);
      });
    },
    // 重置
    fnReset() {
      this.filters = {
        EnterpriseName: "", // 文章标题
        MediaType: 0, // 文章分类
        articleState: 0, // 文章状态
      }
      // this.pageIndex = 1;
      // this.getInit();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
    // 内容
    contentChangeOne(content) {
      this.ueditorValue = content;
    },
    /* oss 直传图片 */
    handleOss(val){
      var obj = { type: val };
      getOssFile(obj).then(data => {
        if (data.resultCode == 1) {
          let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
          let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
          let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
          let ossfile = data.resultObj.directory; // 保存路径
          let ossbucket = data.resultObj.bucket; // bucket
          localStorage.setItem('keyossId',ossId);
          localStorage.setItem('keyossSecret',ossSecret);
          localStorage.setItem('keyossHost',ossHost);
          localStorage.setItem('keyossfile',ossfile);
          localStorage.setItem('keyossbucket',ossbucket);
        }
      })
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },

  },
  filters: {
    playvolume:function(arg) {
      if(arg >= 10000) {
        return parseFloat(arg/10000).toFixed(1) + 'W'
      } else if (arg >= 1000) {
        return parseFloat(arg/1000).toFixed(1) + 'K'
      } else {
        return arg
      }
    }
  },
  created() {
    this.getInit(); // 查询列表
  }
}
</script>
<style scoped lang="less">
/* 基本信息 */
.watch_msg {
  width: 96%;
  margin: 0 auto;
}
/* 基本信息 title */
.typeface {
  font-size: 15px;
  line-height: 33px;
}
.formItem {
  width: 50%;
  display:flex;
  justify-content: space-between;
}
/* 封面图片 */
.coverPhoto .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.coverPhoto .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eeeeee;
  text-align: center;
}
// 品牌店/特价商品
.avatarUploaderIcon {
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #8c939d;
  border: 1px solid #eeeeee;
  font-size: 28px;
  text-align: center;
  margin-right: 20px;
  cursor: pointer;
}
// 删除文品牌店/特价商品
.deletePP {
  position:absolute;
  right: 10px;
  top: -18px;
  cursor: pointer;
}
.brandImg {
  width: 80px;
  height: 80px;
  line-height: 80px;
  margin-right:15px;
  margin-top: -13px;
}
.brandDiv {
  max-height:245px;
  overflow: auto;
  height: auto;
  border: 1px solid #eee;
  padding: 10px;
}
.brandStoreClass {
  height: 100px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.dlStyle {
  width: 70%;
  margin: 0 auto;
  float: left;
}
.dtDiv {
  width: 30%;
  float: left;
}
/* 图片 */
.dtImage {
  width: 90%;
  height: 90px;
}
.ddDiv {
  width: 70%;
  height: 90px;
  float: left;
}
.ddDiv b {
  width: 100%;
  padding-top: 10px;
  display: inline-block;
}
/* 添加按钮区域 */
.confirmBtn {
  width: 30%;
  float: right;
  text-align: center;
}
.noPrice {
  margin-top: 25px;
}
// 添加标签
.chooseDia {
  width: 100%;
  height: 365px;
  border: 1px solid #f6f6f6;
  font-size: 12px;
  margin: auto;
  overflow: hidden;
  overflow: scroll;
  .searchTop {
    width: 100%;
    display: inline-block;
    padding: 15px 0 15px 0;
    border-top: 1px solid #f6f6f6;
    border-bottom: 1px solid #f6f6f6;
    overflow: hidden;
    span {
      margin-left: 20px;
      font-size:16px;
    }
  }
  .searchBot {
    padding: 20px 20px 30px 20px;
    p {
      cursor: pointer;
      display: inline-block;
      padding: 8px;
      background: #f0f0f0;
      border-radius: 3px;
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .activeP {
      color: #fff;
      background: #F56C6C;
      font-weight: bold;
    }
  }
}
// 保存标签
.chooseBtn {
  text-align: center;
  margin-top: 10px;
}
// 选择
.choice {
  width: 100px;
  height: 40px;
  color: #888;
  text-align: center;
  cursor: pointer;
}
.choice:hover {
  color: #F56C6C;
}
.labelSpan {
  display: inline-block;
  padding: 0 10px;
  height: 36px;
  border: 1px solid #eee;
  text-align: center;
  margin-left: 10px;
}
// 文章图片
.upload .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.upload .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eee;
  text-align: center;
}
// 删除文章图片
.deletePicture {
  width: 20px;
  position:absolute;
  right: 6px;
  top: -8px;
  z-index: 1;
  cursor: pointer;
}
.imgPicture {
  width: 80px;
  height: 80px;
  margin-right:15px;
}

// 查看大图
.imgDialog {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.publisherBtn {
  display: inline-block;
  width: 80px;
  height: 40px;
  color: #F56C6C;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
}
// 发布人
.disoutline {
  max-height: 260px;
  height: auto;
  overflow: auto;
  border: 1px solid #eee;
  padding: 0 15px 0 15px;
}
.disinline {
  position: relative;
  height: auto;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  cursor: pointer;
}
.disinline>img {
  width:50px;
  height:50px;
  cursor: pointer;
}
.disinline>span {
  margin-left: 10px;
  cursor: pointer;
}
.elRadio {
  position: absolute;
  top: 15px;
  right: 0px;
}
</style>


// WEBPACK FOOTER //
// articleReviewAndRelease.vue?125cfde7